import { Controller } from "@hotwired/stimulus"

// ForzaAziendale di components/ForzaAziendale.js (31a5bd1): «Collega» solo con un documento scelto, «Conferma sul
// documento» solo con valore e mese; durante un invio (busy) i due pulsanti restano spenti.
export default class extends Controller {
  static targets = ["documento", "collega", "valore", "mese", "conferma"]

  connect() {
    this.busy = false
    this.aggiorna()
  }

  aggiorna() {
    if (this.hasCollegaTarget) this.collegaTarget.disabled = this.busy || !this.documentoTarget.value
    if (this.hasConfermaTarget) this.confermaTarget.disabled = this.busy || this.valoreTarget.value === "" || !this.meseTarget.value
  }

  inizia() {
    this.busy = true
    this.aggiorna()
  }

  // un invio senza risposta (rete, sessione): il toast dell'originale (formatApiErrorDetail(undefined))
  errore() {
    window.toast?.error("Si è verificato un errore. Riprova.")
  }

  fine() {
    this.busy = false
    this.aggiorna()
  }
}
